import {Component, Directive, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {
    ControlContainer, NG_VALUE_ACCESSOR, NgForm
} from "@angular/forms";
import {CVA} from "./cva";
import {UIFormEngineComponentMetadata} from "./form";


@Component({
    selector: 'ui-input-number',
    template: `

	    <div class="ui-input-presentation" *ngIf="presentationMode">
		    {{cva.value}}
	    </div>


	    <ng-container *ngIf="!presentationMode">
		    <input

			    class="form-control"
			    [(ngModel)]="cva.value"
			    (ngModelChange)="writeValueFromInput($event)"
			    [name]="name"
			    [inputNumberValidator]="metadata"
			    #test="ngModel"
			    (focus)="focus()"
			    (focusout)="focusout()"
				[placeholder]="'('+(metadata?.options?.placeholder?metadata?.options?.placeholder:metadata?.label)+')'"
		    />
		    <ui-input-errors [errors]="test.errors"></ui-input-errors>
	    </ng-container>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UIInputNumberComponent),
            multi: true
        }
    ],
    // this is mandatory for the ngForm to be invalid if input is invalid : https://medium.com/@a.yurich.zuev/angular-nested-template-driven-form-4a3de2042475
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]

})
export class UIInputNumberComponent extends CVA {
    @Input() metadata: UIFormEngineComponentMetadata;
    @Input() name;
    @Input() presentationMode = false;

    // !FORMAT
    focusout() {
        this.format();
    }

    focus() {
        this.unformat();
    }

    unformat() {
        if (!this.cva.value) return;
        this.cva.value = this.cva.value.replace(/,/g, '');

    }

    format() {
        if (!this.cva.value) return;
        this.cva.value = this.formatMoney(this.cva.value, this.metadata.options.decimals);
    }

    formatMoney(n, c): string {
        n = n.replace(/,/g, '');
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        let d = ".";
        let t = ",";
        let s = n < 0 ? "-" : ""
        s = n < 0 ? "-" : ""
        let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
        let j: any = 0;
        j = (j = i.length) > 3 ? j % 3 : 0;
        let ret = s + (j ? i.substr(0, j) + t : "")
            + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t)
            + (c ? d + Math.abs(n - Number(i)).toFixed(c).slice(2) : "");

        return ret;
    };
}



